(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acros-promo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MM = { 1: 10, 2: 20, 3: 30, 4: 40 };
  var PLATE = { staal: ['#8C939B', '#4B5158'], rvs: ['#D5DADF', '#9AA2AA'], alu: ['#EEF0F2', '#BFC5CB'], mix: ['#B0B6BD', '#6B727A'] };

  function geo(mm) {
    var h = 10 + mm * 1.6, base = 200, y = base - h, tip = y - 16;
    return {
      body: { y: tip - 108 }, neck: { y: tip - 38 },
      nozzle: { d: 'M214 ' + (tip - 16) + 'H238L232 ' + tip + 'H220Z' },
      arc: { y: tip - 2, height: h + 26 },
      plateL: { y: y, height: h }, plateR: { y: y, height: h }, heat: { y: y, height: h },
      sparks: { d: 'M222 ' + (base + 6) + 'l-10 14M230 ' + (base + 6) + 'l10 16M226 ' + (base + 8) + 'v18M218 ' + (base + 4) + 'l-18 8M234 ' + (base + 4) + 'l18 10' },
      dim: { d: 'M428 ' + y + 'H446M428 ' + base + 'H446M437 ' + y + 'V' + base }
    };
  }

  function update(root) {
    var mat = root.getAttribute('data-mat') || 'staal', thk = root.getAttribute('data-thk') || '2';
    var el = function (n) { return root.querySelector('[data-el="' + n + '"]'); };
    root.querySelectorAll('.acpr__opt').forEach(function (b) {
      var cur = b.getAttribute('data-group') === 'mat' ? mat : thk;
      b.setAttribute('aria-pressed', b.getAttribute('data-val') === cur ? 'true' : 'false');
    });
    root.querySelectorAll('.acpr__combo').forEach(function (c) {
      c.classList.toggle('is-on', c.getAttribute('data-mat') === mat && c.getAttribute('data-thk') === thk);
    });
    var url = root.getAttribute('data-url') || '#';
    el('cta').setAttribute('href', url + (url.indexOf('?') > -1 ? '&' : '?') + 'materiaal=' + mat + '&dikte=' + thk);
    var g = geo(MM[thk] || 20);
    Object.keys(g).forEach(function (n) {
      var node = el(n);
      if (!node) return;
      Object.keys(g[n]).forEach(function (a) { node.setAttribute(a, g[n][a]); });
    });
    var pc = PLATE[mat] || PLATE.staal;
    if (el('stop1')) el('stop1').setAttribute('stop-color', pc[0]);
    if (el('stop2')) el('stop2').setAttribute('stop-color', pc[1]);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-acpr]').forEach(function (root) {
      if (root.getAttribute('data-ready')) return;
      root.setAttribute('data-ready', '1');
      update(root);
      var touched = { mat: false, thk: false };
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.acpr__opt');
        if (btn) {
          var grp = btn.getAttribute('data-group');
          root.setAttribute(grp === 'mat' ? 'data-mat' : 'data-thk', btn.getAttribute('data-val'));
          update(root);
          /* beide vragen zelf beantwoord: knop laten opvallen (één keer per sectie) */
          touched[grp] = true;
          if (touched.mat && touched.thk && !root.classList.contains('is-ready')) root.classList.add('is-ready');
          return;
        }
        if (e.target.closest('[data-el="cta"]')) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'configurator_promo_click',
            promo_material: root.getAttribute('data-mat') || '',
            promo_thickness: Number(root.getAttribute('data-thk')) || null,
            promo_location: root.getAttribute('data-template') || ''
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  $('.scroll-to').on('click', function(evt) {
    evt.preventDefault();
    let data = $(this).data('pointer')

    $('html, body').animate(
    { scrollTop: $(document).find('[data-anchor="' + data + '"]').offset().top - 48},
    300
    );
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-downloads"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  $('.scroll-to').on('click', function(evt) {
    evt.preventDefault();
    let data = $(this).data('pointer')

    $('html, body').animate(
    { scrollTop: $(document).find('[data-anchor="' + data + '"]').offset().top - 48},
    300
    );
  });

  $(window).scroll(function(){
    position = $(this).scrollTop();
    selector = $('.support-downloads__overview-heading');
    selector.each(function(){
      let ID = $(this).data('anchor');
      
      let selector = ".support-downloads__overview";
      let target = $(selector).find('[data-anchor="' + ID + '"]').offset().top - 49;

      if(position>=target){
      $('.support-downloads__menu-item').removeClass("active")
      $('.support-downloads__menu').find('[data-pointer="' + ID + '"]').addClass('active');
      }
    })
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-header"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  $('.scroll-to').on('click', function(evt) {
    evt.preventDefault();
    let data = $(this).data('pointer')

    $('html, body').animate(
    { scrollTop: $(document).find('[data-anchor="' + data + '"]').offset().top - 48},
    300
    );
  });
});

  } catch(e) { console.error(e); }
})();
})();
